import { User } from '.';

export interface ProgramCountryNominationReviewer {
  programCountryNominationReviewerId: number;
  programId: number;
  countryId: number;
  emailAddress: string;
  user?: User;
}

export function blankProgramCountryNominationReviewer(): ProgramCountryNominationReviewer {
  return {
    programCountryNominationReviewerId: 0,
    programId: 0,
    countryId: 0,
    emailAddress: '',
  };
}
